import React, { useEffect, useRef, useState } from "react";

import {
  Box,
  Text,
  Divider,
  Flex,
  Tooltip,
  Icon,
  Spinner,
  Button,
} from "@chakra-ui/react";
import { IoHelpCircle } from "react-icons/io5";
import { RiFileExcel2Line } from "react-icons/ri";
import { PrintButtonPendencias } from "../../../../components/PrintButtonPendencias";
import {
  criancaFunc,
  Permission,
  servicos,
} from "../../../../../helpers/Funcionalidades";
import { useAuthProvider } from "../../../../../Context/AuthProvider";
import { useAppContext } from "../../../../../Context/MessageContextProvider";
import { PrintButtonPendenciasServico } from "../../../../components/PrintButtonPendenciasServico";
import ServicoAcolhimentoService from "../../../../../main/services/ServicoAcolhimentoService";
import CriancaService from "../../../../../main/services/CriancaService";
import { useHistory } from "react-router-dom";

const Group = ({
  title,
  children,
  mt,
  bgColor,
  py,
  mtDivider,
  dividerFalse,
  marginTitle,
  position,
  regularidade,
  opcoes,
  menuComponent,
  showMenuItemsAtribuicao,
  border,
  scrollToField,
  tooltipText,
  downloadPendencias,
  idCrianca,
  servico,
  idServico,
  voltar,
}) => {
  const { roleKeycloack, user } = useAuthProvider();
  const { idPJ, crianca, servicoData } = useAppContext();
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const anexoRef = useRef(null);
  useEffect(() => {
    scrollToField && scrollToField(anexoRef);
  }, [scrollToField]);

  const nomeArquivoDownload = (headers, fallback) => {
    const disposition = headers?.["content-disposition"];
    const match = disposition?.match(/filename\*?=(?:UTF-8'')?"?([^";]+)"?/i);
    return match ? decodeURIComponent(match[1]) : fallback;
  };

  const getExportarExecel = async () => {
    let res;
    try {
      setLoading(true);

      res = servico
        ? await ServicoAcolhimentoService.getPendenciaServicoDownload(idServico)
        : await CriancaService.getPendenciaDownload(idCrianca);
      const url = window.URL.createObjectURL(res.data);
      const link = document.createElement("a");
      link.href = url;
      link.download = nomeArquivoDownload(res.headers, "pendencias.xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      position={position ? position : ""}
      mt={mt ? mt : "15px"}
      display="block"
      px="18px"
      py={py ? py : "25px"}
      pt={!title ? "10px" : "25px"}
      pb={marginTitle && "5px"}
      borderRadius="10px"
      w={"100%"}
      bgColor={bgColor ? bgColor : "#FFF"}
      border={border ? border : ""}
      ref={anexoRef}
    >
      <Text
        as="div"
        fontWeight={700}
        fontSize="16px"
        display={opcoes && "flex"}
        justifyContent={opcoes && "space-between"}
        lineHeight="21.6px"
        color={`${regularidade ? "#169499" : "#169499"}`}
      >
        <Flex alignItems="center" gap={2} h={voltar && "35px"}>
          {typeof title === "string" ? title?.toUpperCase() : title}{" "}
          {tooltipText && (
            <Tooltip
              textAlign={"justify"}
              label={tooltipText}
              fontSize="md"
              maxW="400px"
            >
              {/* Título em caixa alta fica acima do centro da linha — sobe o
                  ícone para alinhar com o texto. */}
              <Box
                h={"18px"}
                display="flex"
                position="relative"
                top="-2px"
                tabIndex={0}
              >
                <Icon
                  aria-label="Ajuda"
                  color="#6B6C71"
                  as={IoHelpCircle}
                  boxSize="18px"
                />
              </Box>
            </Tooltip>
          )}
        </Flex>
        {opcoes && showMenuItemsAtribuicao && (
          <Box>
            <Box position="relative" mr={"20px"}>
              {!downloadPendencias ? (
                <>
                  <Text as="b" color="black" fontSize={"md"}>
                    Opções
                  </Text>
                  {menuComponent}{" "}
                </>
              ) : (
                <Flex alignItems="center" gap={4}>
                  <Permission
                    roleKeycloack={roleKeycloack}
                    func={
                      servico
                        ? servicos.pendenciasServExportar
                        : criancaFunc.pendenciasExportar
                    }
                    user={user}
                    id={idPJ}
                    visualizar={true}
                  >
                    {loading ? (
                      <Spinner size="sm" />
                    ) : (
                      <Flex
                        alignItems="center"
                        gap={2}
                        cursor="pointer"
                        onClick={() => !loading && getExportarExecel()}
                      >
                        <Flex bg="#006400" rounded="full" p={1}>
                          <RiFileExcel2Line color="white" />
                        </Flex>

                        <Text as="b" color="#006400" fontSize={"md"}>
                          Exportar em Excel
                        </Text>
                      </Flex>
                    )}
                  </Permission>

                  <Permission
                    roleKeycloack={roleKeycloack}
                    func={
                      servico
                        ? servicos.pendenciasServImprimir
                        : criancaFunc.pendenciasImprimir
                    }
                    user={user}
                    id={idPJ}
                    visualizar={true}
                  >
                    {servico ? (
                      <PrintButtonPendenciasServico
                        idServico={idServico}
                        dados={servicoData}
                        user={user}
                        servico={true}
                      />
                    ) : (
                      <PrintButtonPendencias
                        idCrianca={idCrianca}
                        dados={crianca}
                        user={user}
                      />
                    )}
                  </Permission>
                </Flex>
              )}
            </Box>
          </Box>
        )}
        {opcoes && voltar && (
          <Flex alignItems="center" gap={4}>
            <Button
              color="#FFF"
              backgroundColor="#169499"
              fontWeight={700}
              fontSize="15px"
              lineHeight="21.6px"
              _hover={{ bg: "#169499" }}
              onClick={() => history.goBack()}
              px="35px"
            >
              Voltar
            </Button>
          </Flex>
        )}
      </Text>

      {!dividerFalse && (
        <Divider
          mt={mtDivider ? mtDivider : "10px"}
          orientation="horizontal"
          borderColor={"#DDEBEA"}
        />
      )}
      {children}
    </Box>
  );
};

export default Group;
